/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { CannedCollectionModule } from '@coursera-web/cds-labs';

import { Grid, PageGridContainer } from '@coursera/cds-core';
import type { MerchandisingModuleModuleType } from '@coursera/event-pulse-types';
import { useTracker, useVisibilityTracker } from '@coursera/event-pulse/react';

import getCardTakeoverProps from 'bundles/unified-description-page-common/module-renderers/upsell/getCardTakeoverProps';

export const styles = {
  promoUnitsModule: css`
    display: flex;
    flex-direction: row;
    justify-content: center;

    /* Outermost container for CannedCollectionModule */
    > div {
      display: flex !important;
      padding: 0 !important;
      margin: 0 !important;
    }

    /* Grid container for CannedCollectionModule */
    > div > div {
      padding: 0 !important;
      margin: 0;
    }

    /* Grid item wrapper for CannedCollectionModule */
    > div > div > div {
      margin: 0 !important;
      padding: 0 !important;
      gap: 0;
    }

    /* Grid item for CannedCollectionModule. Removes space between sections */
    > div > div > div > div > div > div {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
  `,
};

export const CardTakeoverExperimentModuleRenderer = () => {
  const track = useTracker();
  const { courseraPlusProps, courseraForBusinessProps } = getCardTakeoverProps();

  const handleCourseraPlusClick = () => {
    track('click_merchandising_module', {
      merchandisingModule: {
        moduleType: 'promo_unit' as MerchandisingModuleModuleType,
        heading: courseraPlusProps.headline,
      },
      button: {
        name: 'promo_cta',
        linkType: 'internal',
        linkName: courseraPlusProps.ctaText,
        linkURL: courseraPlusProps.target,
      },
    });
  };

  const handleCourseraForBusinessClick = () => {
    track('click_merchandising_module', {
      merchandisingModule: {
        moduleType: 'promo_unit' as MerchandisingModuleModuleType,
        heading: courseraForBusinessProps.headline,
      },
      button: {
        name: 'promo_cta',
        linkType: 'internal',
        linkName: courseraForBusinessProps.ctaText,
        linkURL: courseraForBusinessProps.target,
      },
    });
  };

  const visibilityTrackingRef: React.MutableRefObject<HTMLDivElement | null> = useVisibilityTracker(
    'view_merchandising_module',
    {
      merchandisingModule: {
        moduleType: 'promo_unit',
      },
    },
    [],
    { fullyVisible: true }
  );

  const courseraPlusCard = { ...courseraPlusProps, onClick: handleCourseraPlusClick };
  const courseraForBusinessCard = { ...courseraForBusinessProps, onClick: handleCourseraForBusinessClick };
  return (
    <section css={styles.promoUnitsModule} data-testid="card-takeover-experiment-module">
      <PageGridContainer>
        <Grid item xs={12}>
          <div ref={visibilityTrackingRef}>
            <CannedCollectionModule
              cards={[courseraPlusCard, courseraForBusinessCard]}
              size="large"
              color="blue"
              showImageInFull={true}
              showAllEntries={true}
              variantConfig={{
                sm: 'grid',
              }}
            />
          </div>
        </Grid>
      </PageGridContainer>
    </section>
  );
};
